import React from 'react';
import { useLocation } from 'react-router-dom';

interface InfoBoxProps {
  isLoading: boolean;
}

const InfoBox: React.FC<InfoBoxProps> = ({ isLoading }) => {
  const location = useLocation();
  const isAnalyzed = location.pathname.includes('/result');


  if (isLoading) {
    return (
      <div className="p-4 bg-blue-50 border border-blue-200 rounded-md max-w-[600px] mx-auto">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3 text-sm text-blue-700">
            <div>
              Analyzing Essay...
              <br />
              Please be patient, this just takes a moment
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isAnalyzed) {
    return (
      <div className="p-4 bg-green-50 border border-green-200 rounded-md max-w-[400px] mx-auto">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3 text-sm text-green-700">
            <div>Essay saved to drafts</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 bg-blue-50 border border-blue-200 rounded-md max-w-[600px] mx-auto">
      <div className="flex items-center">
        <div className="flex-shrink-0">
          <svg className="h-5 w-5 text-blue-400 app-color" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
          </svg>
        </div>
        <div className="ml-3 text-sm text-blue-700">
          <div>1. Select an essay prompt from the required options</div>
          <div>
            2. Paste your essay above or select one of your previous
            drafts
          </div>
          <div>3. Hit Analyze</div>
        </div>
      </div>
    </div>
  );
};

export default InfoBox; 